import { useCallback } from 'react';
import { LockFill, LockOpen } from '@crabs-ai/web-icons';
import { ToolButton } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import { lockTrack, unlockTrack } from '../../state/actions/lock-track';
import { TrackType } from '../../state/types';
import { useWriteContext } from '../../utils/use-context';

export const TimelineLockTrack = ({ track }: { track: TrackType }) => {
  const { setState } = useWriteContext();
  const t = useTranslations();

  const toggle = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();

      setState({
        update: (state) =>
          track.locked
            ? unlockTrack(state, track.id)
            : lockTrack(state, track.id),
        commitToUndoStack: true,
      });
    },
    [track.locked, setState, track.id],
  );

  const onPointerDown = useCallback((e: React.PointerEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <ToolButton
      size="sm"
      state={track.locked ? 'selected' : 'default'}
      onClick={toggle}
      onPointerDown={onPointerDown}
      isShowTooltip
      tooltipNode={
        track.locked ? t('Editor.timeline.unlock') : t('Editor.timeline.lock')
      }
      tooltipPosition="top"
    >
      {track.locked ? <LockFill /> : <LockOpen />}
    </ToolButton>
  );
};
